/**
 * TanStack Query hook for GET /api/v1/admin/import-status (Phase 12.5).
 *
 * The endpoint returns a single snapshot of all four import surfaces:
 * Freshdesk legacy, Gemini archive, inbound email queue, Buyist eCommerce
 * API brand sync. The endpoint itself reports ``enabled: false`` for any
 * component that has not been configured yet, so the UI just maps the
 * data straight onto the four import-status cards.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import api from "@/lib/api";
import type { ImportStatusResponse } from "@/types/api";

export const ADMIN_IMPORT_STATUS_QUERY_KEY = [
  "admin",
  "import-status",
] as const;

export function useAdminImportStatus(): UseQueryResult<ImportStatusResponse> {
  return useQuery({
    queryKey: ADMIN_IMPORT_STATUS_QUERY_KEY,
    queryFn: async () => {
      const response = await api.get<ImportStatusResponse>(
        "/admin/import-status",
      );
      return response.data;
    },
  });
}
